import client from "api/client";
import { ApiEndpoints } from "api/endpoints";
import { Hall } from "../../../backend/src/halls/types";

export function getHalls() {
  return client.get<Hall[]>(ApiEndpoints.Halls);
}
